import React, { useState, useEffect } from 'react';
import api from '../api/axiosInstance';
import baseApiConfig from '../config/apiConfig';

const AnnouncementBanner = ({ position }) => {
  const [announcement, setAnnouncement] = useState(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const fetchAnnouncement = async () => {
      try {
        const response = await api.get(`/api/Admin/Announcement/getbyposition/${position}`,{ skipAuthCheck: true });
        setAnnouncement(response.data);
      } catch (error) {
        console.error("Error fetching announcement", error);
      }
    };
    fetchAnnouncement();
  }, [position]);

  if (!isVisible || !announcement || (!announcement.content && !announcement.imageUrl)) {
    return null;
  }

  return (
    <div 
      className={`announcement-ad-banner-${position}`} 
      style={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column', // Content ko image ke niche laane ke liye
        backgroundColor: '#ffffff',
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '24px 16px 16px 16px',
        margin: '15px auto',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
        width: '100%',
        maxWidth: '1140px',
        boxSizing: 'border-box',
        gap: '12px',
        overflow: 'hidden'
      }}
    >
      {/* Ad Tag Badge */}
      {/* <span style={{
        position: 'absolute',
        top: '6px',
        left: '12px',
        fontSize: '10px',
        textTransform: 'uppercase',
        color: '#888',
        letterSpacing: '0.5px',
        fontWeight: '600'
      }}>
        Ad
      </span> */}

      {/* Close / Cut Button ('X') */}
      <button 
        onClick={() => setIsVisible(false)}
        style={{
          position: 'absolute',
          top: '6px',
          right: '8px',
          background: '#f1f1f1',
          border: 'none',
          borderRadius: '50%',
          width: '24px',
          height: '24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '14px',
          fontWeight: 'bold',
          color: '#555',
          cursor: 'pointer',
          zIndex: 2,
          transition: 'background 0.2s'
        }}
        onMouseOver={(e) => e.target.style.backgroundColor = '#e0e0e0'}
        onMouseOut={(e) => e.target.style.backgroundColor = '#f1f1f1'}
        title="Close Ad"
      >
        &times;
      </button>

      {/* Top: Full Image Display */}
      {announcement.imageUrl && (
        <div style={{ width: '100%', textAlign: 'center' }}>
          <img 
            src={baseApiConfig.BASE_API_URL + announcement.imageUrl} 
            alt="Advertisement" 
            style={{ 
              width: '100%', 
              maxHeight: '400px', 
              objectFit: 'contain', // Image poori dikhegi aur cut nahi hogi
              borderRadius: '6px',
              display: 'block',
              margin: '0 auto'
            }} 
          />
        </div>
      )}

      {/* Bottom: HTML Content */}
      <div 
        style={{ 
          width: '100%',
          fontSize: '14px', 
          color: '#2c3e50',
          lineHeight: '1.5',
          textAlign: 'left'
        }}
        dangerouslySetInnerHTML={{ __html: announcement.content }} 
      />
    </div>
  );
};

export default AnnouncementBanner;